import { ShieldCheck, Instagram } from "lucide-react";
import Reveal from "./Reveal";

export default function About() {
  return (
    <section
      id="sobre"
      data-testid="about-section"
      className="relative scroll-mt-24 border-y border-white/10 bg-[#161B22]"
    >
      <div className="mx-auto grid max-w-7xl gap-14 px-5 py-24 sm:px-8 sm:py-32 lg:grid-cols-2 lg:items-center">
        <Reveal>
          <div className="relative">
            <div className="overflow-hidden rounded-2xl border border-white/10">
              <img
                src="/images/darlei.jpg"
                alt="Darlei, guia de turismo, em mirante com vista do Rio de Janeiro"
                className="aspect-[4/5] w-full object-cover"
              />
            </div>
            <div
              data-testid="cadastur-badge"
              className="absolute -bottom-5 left-5 flex items-center gap-2 rounded-full border border-amber-400/40 bg-[#0D1117] px-5 py-3 shadow-[0_10px_40px_rgba(0,0,0,0.5)]"
            >
              <ShieldCheck className="h-5 w-5 text-amber-400" />
              <span className="font-mono text-[11px] font-semibold uppercase tracking-[0.2em] text-amber-300">
                Cadastur 19.967376.16-7
              </span>
            </div>
            <div className="absolute -right-3 -top-3 hidden rounded-xl border border-white/10 bg-[#0D1117]/80 px-4 py-3 backdrop-blur-md sm:block">
              <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-stone-400">
                Base
              </p>
              <p className="font-display text-sm font-bold text-stone-100">
                Rio de Janeiro, RJ
              </p>
            </div>
          </div>
        </Reveal>

        <div>
          <Reveal>
            <p className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-amber-400">
              Sobre o Darlei
            </p>
            <h2 className="mt-4 font-display text-3xl font-extrabold leading-tight tracking-tight text-stone-50 sm:text-4xl lg:text-5xl">
              Prazer, eu sou o{" "}
              <em className="font-accent font-medium italic text-amber-400">Darlei.</em>
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-6 text-base leading-relaxed text-stone-300 sm:text-lg">
              Sou Darlei, guia de turismo cadastrado no CADASTUR. Desde 2021 acompanho
              visitantes no Rio e fora dele e agora atuo
              profissionalmente. Meu objetivo é oferecer passeios bem planejados,
              confortáveis e sem pressa.
            </p>
            <a
              href="https://instagram.com/darleiguiarj"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="about-instagram-link"
              className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-amber-400 transition-colors duration-300 hover:text-amber-300"
            >
              <Instagram className="h-4 w-4" />
              @darleiguiarj no Instagram
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
